export const SearchResultsPopoverId = Symbol('SEARCH_RESULTS_POPOVER');
export const NotificationsPopoverId = Symbol('NOTIFICATIONS_POPOVER');
export const MemberMenuPopoverId = Symbol('MEMBER_MENU_POPOVER');
export const TeamlessCollaborationPromptPopoverId = Symbol(
  'TEAMLESS_COLLABORATION_PROMPT_POPOVER',
);
export const UpgradePromptPlanSelectionPopoverId = Symbol(
  'UPGRADE_PROMPT_PLAN_SELECTION_POPOVER',
);
